import { SlicesUIElement, html } from '../element/element';
import { css } from './carousel.css.js';
import '../button/button.js';
import '../icon/icon.js';

/**
 * 
 * @element slicesui-carousel
 * 
 */

export class SlicesUICarousel extends SlicesUIElement {

  static get properties() {
    return {
      _scrollX: {
        observe: true,
        changedHandler: '_scrollXChanged'
      }
    };
  }

  constructor() {
    super();
    this._scrollX = 0;
  }

  set _scrollX(val) {
    if(val < 0) return this['#_scrollX'] = 0;
    const $container = this.shadowRoot.querySelector('#scrollContainer');
    const maxWidth = ($container) ? $container.scrollWidth - this.offsetWidth : 999999;
    if(val > maxWidth) return this['#_scrollX'] = maxWidth;
    this['#_scrollX'] = val;
  }

  /**
   * @private
   */
  get template() {
    return html`
      <style>${css}</style>
      <section>
        <slicesui-button
          class="left"
          @click="${this._handleClickScrollLeft}"
        ><slicesui-icon icon="keyboard_arrow_left"></slicesui-icon></slicesui-button>
        <main>
          <div id="scrollContainer"><slot></slot></div>
        </main>
        <slicesui-button
          class="right"
          @click="${this._handleClickScrollRight}"
        ><slicesui-icon icon="keyboard_arrow_right"></slicesui-icon></slicesui-button>
      </section>
    `;
  }

  _handleClickScrollLeft() {
    const $main = this.shadowRoot.querySelector('main');
    const $btn = this.shadowRoot.querySelector('slicesui-button');
    if(!$main) return;
    this._scrollX -= this.scrollWidth - ($btn.offsetWidth * 2);
  }

  _handleClickScrollRight() {
    const $main = this.shadowRoot.querySelector('main');
    const $btn = this.shadowRoot.querySelector('slicesui-button');
    if(!$main) return;
    this._scrollX += this.scrollWidth - ($btn.offsetWidth * 2);
  }

  _scrollXChanged(oldVal, newVal) {
    const $main = this.shadowRoot.querySelector('main');
    const $scrollContainer = this.shadowRoot.querySelector('#scrollContainer');
    if(!$main) return;
    const supportsSmoothScroll = CSS.supports('scroll-behavior:smooth');
    if(supportsSmoothScroll) return $scrollContainer.scrollTo(this._scrollX, 0);
    $main.style.setProperty('margin-left', `${(0-newVal)}px`);
  }

}

window.customElements.define('slicesui-carousel', SlicesUICarousel);